import { render, staticRenderFns } from "./LoansDetailsSummary.vue?vue&type=template&id=7145af29&scoped=true"
import script from "./LoansDetailsSummary.vue?vue&type=script&lang=js"
export * from "./LoansDetailsSummary.vue?vue&type=script&lang=js"
import style0 from "./LoansDetailsSummary.vue?vue&type=style&index=0&id=7145af29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145af29",
  null
  
)

export default component.exports